/**
 * Paths for chart.
 * - proxy: Next.js API route used by client on BZ domain (/api/chart)
 * - upstream: external data API (server-side)
 */
export const chartRoutes = {
  chart: { proxy: 'chart', upstream: 'v2/chart' },
} as const;
